import { NotifyHttp } from '@rhybus/api'

import { apiPath, fetchProvider } from './api'

/**mpfNotifyHttp:
 * Notify - Send notifications to other users.
 */
export const mpfNotifyHttp = () => {
  try {
    return new NotifyHttp(fetchProvider, apiPath)
  } catch (error) {
    console.error(`
    Error while fetching the API using endpoint NotifyHttp. \n
    fetchProvider:${fetchProvider} \n
    apiPath:${apiPath} \n
    Error:${error}`)    
    throw error
  }
}
